import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach bearer token from localStorage as fallback (cookies may be blocked cross-origin)
api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("aig_access_token");
  if (token) {
    cfg.headers = cfg.headers || {};
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  return cfg;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  return JSON.stringify(detail);
}

export async function safeBlobDownload(url, filename, onError) {
  try {
    const t = localStorage.getItem("aig_access_token");
    const res = await fetch(url, {
      credentials: "include",
      headers: t ? { Authorization: `Bearer ${t}` } : {},
    });
    if (!res.ok) {
      let msg = `Download failed (${res.status})`;
      try {
        const data = await res.json();
        if (data?.detail) msg = typeof data.detail === "string" ? data.detail : JSON.stringify(data.detail);
      } catch (_) {}
      onError?.(msg);
      return false;
    }
    const blob = await res.blob();
    const objUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = objUrl;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(objUrl);
    return true;
  } catch (e) {
    onError?.(e?.message || "Download failed");
    return false;
  }
}
